import { ExceptionsService } from "../services/utelize/general/exceptions-service";
import { InventoryStatusStyleDefault, InventoryStatusStyles } from "../consts";

export function formatInventoryDate(exceptionsService: ExceptionsService,
                                    value            : string | null | undefined
                                   ): string {
  try {
    if (!value)
      return '';

    if (!/^\d{4}-\d{2}-\d{2}/.test(value))
      return value;

    return value.substring(8, 10) + '/' + value.substring(5, 7) + '/' + value.substring(0, 4);
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return '';
  }
}

export function getInventoryStatusStyle(exceptionsService: ExceptionsService,
                                        status           : string | null | undefined
                                       ): { colour: string; icon: string; } {
  try {
    return InventoryStatusStyles[(status ?? '').trim().toLowerCase()] ?? InventoryStatusStyleDefault;
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return InventoryStatusStyleDefault;
  }
}
